<template>
  <CardCta
    :buttonProps="{
      type: 'primary',
      class: $style.buttonProps,
    }"
    :class="$style.card"
    :ctaText="widgetInfo.buttonText"
    @click="handleRedirect()"
  >
    <template v-slot:header>
      <HeadingMedium
        :hasMargin="false"
      >
        {{ widgetInfo.title }}
      </HeadingMedium>
    </template>
    <template v-slot:body>
      <ParagraphBody
        :class="$style.widgetText"
      >
        {{ widgetInfo.text }}
      </ParagraphBody>
    </template>
  </CardCta>
</template>

<script>
import {
  CardCta,
  HeadingMedium,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import Util from 'client/util/Util';

export default {
  name: 'NoDataWidgetCard',
  components: {
    CardCta,
    HeadingMedium,
    ParagraphBody,
  },
  props: {
    widgetInfo: {
      type: Object,
      required: true,
    },
    widgetUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleRedirect() {
      Util.redirect(this.widgetUrl);
    },
  },
};
</script>

<style module>
@value (cardShadow1) from '~css/shadows.css';

.buttonProps {
  margin-left: auto;
  margin-top: var(--jc-spacer);
}

.card {
  box-shadow: cardShadow1;
}

.widgetText {
  color: var(--jc-color-neutral-text-descriptive);
}
</style>
